import { showAlert } from "../../config/utils";
import { fcaReportGateway } from "../../services/authorizationService";

class MyUploadAdapter {
    constructor(loader) {
        this.loader = loader;
    }
    upload() {
        return new Promise((resolve, reject) => {
            this.loader.file.then(file => {
                const ext = file.name.split(".").pop().toLowerCase();
                const allowed = ["png", "jpg", "ttf", "jpeg", "svg"];
                if (!allowed.includes(ext)) {
                    showAlert("Invalid file type. Allowed formats: JPG, JPEG, PNG, SVG, TTF.");
                    reject("Invalid file type");
                    return;
                }
                const data = new FormData();
                data.append("file", file);
                fcaReportGateway
                    .post("/smart-chart/property/image_upload/", data)
                    .then(result => {
                        resolve({
                            default: result?.data.file_name
                        });
                    })
                    .catch(error => {
                        if (error) showAlert(error);
                        reject(error);
                    });
            });
        });
    }
    abort() {}
}

export function MyUploadAdapterPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new MyUploadAdapter(loader);
    };
}
